import { createSelector } from 'reselect';

const   selectTemplates = (state: any) => state.templates;


export const   selectTemplatesCurrentItem = createSelector([  selectTemplates], (templates) => templates.current);

export const   selectTemplatesListItems = createSelector([  selectTemplates], (templates) => templates.list);

export const   selectTemplatesItemById = (itemId: any) =>
    createSelector(  selectTemplatesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTemplatesCreatedItem = createSelector([  selectTemplates], (templates) => templates.create);

export const selectTemplatesUpdatedItem = createSelector([  selectTemplates], (templates) => templates.update);

export const selectTemplatesReadItem = createSelector([  selectTemplates], (templates) => templates.read);
export const selectTemplatesQueryItems = createSelector([selectTemplates], (templates) => templates.query);
export const selectTemplatesDeletedItem = createSelector([  selectTemplates], (templates) => templates.delete);

export const   selectTemplatesearchedItems = createSelector([  selectTemplates], (templates) => templates.search);

export const selectTemplatesItemsCount = createSelector([  selectTemplates], (templates) => templates.count);

export const selectTemplatesItemsFilter = createSelector([  selectTemplates], (templates) => templates.filter);